
import React from 'react';
import './App.css';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SupportPage from '../pages/support';
import DownloadPage from '../pages/download';
import NotFoundPage from '../pages/not-found';
import Landing from '../pages/alternate-home';

const App: React.FC = () => {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/download" element={<DownloadPage />} />
        {/* <Route path="/chart" element={<ChartPage />} /> */}
        <Route path="*" element={<NotFoundPage />} />
        {/* <Route path="/alternate" element={<Landing />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
